import {createSelector} from "reselect";
import {META_FETCHED} from "../actions/types";
import reducerRegistry from "./reducerRegistry";


export default function meta(state = {}, action = {}) {
    switch (action.type) {
        case META_FETCHED:

            return {...state, ...action.data};
        default:
            return state;
    }
}

reducerRegistry.register("meta", meta);

const metaSelector = (state) => state.meta;

export const allMetaSelector = createSelector(metaSelector, entityHash =>
   entityHash
);



// WEBPACK FOOTER //
// ./src/reducers/meta.js